<template>
  <mag-layout :title="title" @caleclick="switchSilder">
    <div class="content">
      <loading :active.sync="loading" loader="bars" color="#00ab00"></loading>
      <div class="left chapters">
        <div class="listtitle">單元閱讀</div>
        <router-link
          :to="`/read/${brandCode}/${issueId}/0`"
          v-if="coverchepter.thumbImage"
          class="chaptercard firstchepter"
        >
          <image-loader :src="coverchepter.thumbImage[0]" alt="" />
          <div class="chaptertitlte">{{ clipTitle(coverchepter.title) }}</div>
        </router-link>
        <a
          @click="native2Chapter(chapter.mnId)"
          v-for="chapter in leftchapters"
          :key="chapter.mnId"
          class="chaptercard"
        >
          <image-loader :src="chapter.thumbImage[0]" alt="" />
          <div class="chaptertitlte">{{ clipTitle(chapter.title) }}</div>
        </a>
      </div>
      <router-link class="coverCt" :to="`/read/${brandCode}/${issueId}`">
        <image-loader class="cover" :src="cover" width="auto" />
        <div class="mark">
          <span class="iconfont iconread read"></span>
          <span class="readtip">閱讀整本</span>
        </div>
      </router-link>

      <div class="right chapters">
        <div class="listtitle">單元閱讀</div>
        <a
          @click="native2Chapter(chapter.mnId)"
          v-for="chapter in rightchapters"
          :key="chapter.mnId"
          class="chaptercard"
        >
          <image-loader :src="chapter.thumbImage[0]" alt="" />
          <div class="chaptertitlte">{{ clipTitle(chapter.title) }}</div>
        </a>
      </div>
    </div>
    <silder
      :show.sync="showsilder"
      :brandCode="brandCode"
      @close="switchSilder"
    ></silder>
    <template v-solt="ft">
      <mfooter />
    </template>
  </mag-layout>
</template>

<script>
import MagLayout from "../_layout/mag_layout";
import Silder from "../../components/Silder";
import Footer from "../Footer";
import { get } from "../../libs/request";
import { API } from "../../libs/consts";
import { cacheIssue, getCacheIssue } from "../../libs/utils";

export default {
  name: "MagPage",
  components: {
    "mag-layout": MagLayout,
    silder: Silder,
    mfooter: Footer,
  },
  data() {
    return {
      cacheChapter: {},
      loading: false,
      title: "",
      cover: "",
      showsilder: false,
      leftchapters: [],
      rightchapters: [],
      coverchepter: {},
    };
  },
  computed: {
    issueId() {
      return this.$route.params.issueId;
    },
    brandCode() {
      return this.$route.params.brandCode;
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      const item = getCacheIssue(this.issueId);
      if (item && item.title) {
        this.title = item.mgName;
        this.cover = item.cover;
        this.coverchepter = item.pageList[0];
        this.leftchapters = item.pageList.slice(1, 7);
        this.rightchapters = item.pageList.slice(7);
        this.loadChapterData(item.pageList);
      } else {
        this.loading = true;
        get(API.magz.brand.issue(this.issueId), {
          issueId: this.issueId,
          brandCode: this.brandCode,
        })
          .then((rps) => {
            if (rps.errMsg == API.Code.ok) {
              this.title = rps.data.mgName;
              this.cover = rps.data.cover;
              this.coverchepter = rps.data.pageList[0];
              this.leftchapters = rps.data.pageList.slice(1, 7);
              this.rightchapters = rps.data.pageList.slice(7);
              cacheIssue(this.issueId, rps.data);
              this.loadChapterData(rps.data.pageList);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    native2Chapter(mnid) {
      var link = `/read/${this.brandCode}/${this.issueId}/${
        this.cacheChapter[mnid] || 1
      }`;
      this.$router.push(link);
    },

    getStartNo(url) {
      var no = 0;
      try {
        no = url.match(/jpeg\/(?<no>\d+)\.jpg$/).groups.no;
      } catch (err) {
        console.log(err);
      }
      return Number(no);
    },

    loadChapterData: async function (list) {
      list.forEach((item) => {
        get(API.magz.brand.chapter(item.mnId)).then((rps) => {
          if (rps.errMsg == API.Code.ok) {
            var chapter = rps.data;
            this.cacheChapter[chapter.mnId] = this.getStartNo(chapter.pages[0]);
            chapter.pages.forEach((url) => {
              sessionStorage.setItem(
                url,
                JSON.stringify({
                  title: chapter.title,
                  mgName: chapter.mgName,
                  issueNo: chapter.issueNo,
                  htmlContent: chapter.htmlContent,
                  mnId: chapter.mnId,
                  issueId: chapter.issueId,
                })
              );
              if (url == this.cover) this.loadCurrentPager();
            });
          }
        });
      });
    },
    switchSilder() {
      this.showsilder = !this.showsilder;
    },
    clipTitle(title) {
      if (title.length > 14) return title.substr(0, 12) + "...";
      return title;
    },
  },
  watch: {
    issueId() {
      this.loadData();
    },
  },
};
</script>
<style scoped src="./index.css" />